import "core-js/modules/es.object.to-string";
// import Vue from 'vue'
// import VueRouter from 'vue-router'
Vue.use(VueRouter); // 获取原型对象上的push函数

var originalPush = VueRouter.prototype.push; // 修改原型对象中的push方法

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};

var baseRouters = [{
  path: '/',
  redirect: '/login'
}, {
  path: '/init',
  name: 'Init',
  component: function component() {
    return import('@/view/init/index');
  }
}, {
  path: '/login',
  name: 'Login',
  component: function component() {
    return import('@/view/login/index');
  }
}]; // 需要通过后台数据来生成的组件

var createRouter = function createRouter() {
  return new VueRouter({
    routes: baseRouters
  });
};

var router = createRouter();
export default router;